<template>
  <div>
    <div class="blank"/>
    <div class="information-container">
      <div class="item">
        <div class="error-title">
          <i class="fas fa-exclamation-triangle"></i>
          {{message}}
        </div>
        <div class="error-message">
          <div v-for="(message, index) in detail" :key="index">
            {{message}}
          </div>
        </div>
        <div v-if="inquiryCode" class="inquiry-code">
          お問合せコード: {{inquiryCode}}
        </div>

        <div class="flex-center mt27">
          <router-link v-if="isAdmin" :to="{name: 'AdminLogin'}" class="link">戻る</router-link>
          <router-link v-else :to="userBackLink" class="link">トップへ戻る</router-link>
        </div>
      </div>
    </div>
    <div v-if="$isDebug()" class="debug-info">
      <div> - Debug Info -</div>
      {{debugInfo}}
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      detail: '',
      inquiryCode: null,
      debugInfo: 'null',
      userBackLink: {}
    };
  },
  watch: {
    '$route' () {
      this.initialize();
    }
  },
  created: function () {
    this.initialize();
  },
  computed: {
    isAdmin: function () {

      let errorType = this.$route.meta.errorType;

      if (errorType === 'admin') {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    initialize: function () {

      let errorType = this.$route.meta.errorType;
      console.log(errorType);

      if (errorType === '404') {
        this.message = 'ご指定のページは見つかりませんでした';
        this.detail = ['URLをご確認ください'];
      } else if (errorType === 'user') {
        this.message = 'システムエラーが発生しました';
        this.detail = ['しばらくたってから再度リクエストしてください'];
      } else {
        this.message = 'システムエラー';
        this.detail = ['システムエラーが発生しました', 'サポートまでお問合せください'];
      }

      if (!this.isAdmin) {

        let userId = this.$store.getters['auth/userId'];

        if (userId >= 1) {
          this.userBackLink = {name: 'Home'};
        } else {
          this.userBackLink = {name: 'Welcome'};
        }
      }

      if (errorType === '404') {
        return;
      }

      let errorStore = this.$store.getters['errorInfo/errorStore'];
      console.log(errorStore);

      if (errorStore === '' || errorStore === null) {
        this.inquiryCode = null;
        this.debugInfo = null;

        return;
      }

      let codeKey = errorStore + '/reasonCode';
      let debugInfoKey = errorStore + '/debugInfo';

      this.inquiryCode = this.$store.getters[codeKey];
      this.debugInfo = this.$store.getters[debugInfoKey];

      console.log(this.inquiryCode);
      console.log(this.debugInfo);

      if (this.inquiryCode === 'SESSION_ERROR') {

        if (!this.isAdmin) {
          this.$store.dispatch('auth/sessionReset').then();

          // welcomeへ遷移
          this.$router.push({name: 'Welcome'});
          return;

        } else {
          this.$store.dispatch('adminAuth/sessionReset').then();
        }

      }

      if (errorStore === 'errorInfo') {

        let debugInfoKey = errorStore + '/errorMessage';

        let errorMessage = this.$store.getters[debugInfoKey];
        console.log(debugInfoKey, errorMessage);

        this.message = errorMessage.header;

        if (typeof errorMessage.detail === 'string') {
          this.detail = [errorMessage.detail];
        } else {
          this.detail = errorMessage.detail;
        }

      }

    }
  }
};
</script>

<style lang="scss" scoped>

  .inquiry-code {
    margin-top: 20px;
    text-align: center;
  }

  .debug-info {
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    text-align: left;
    padding: 10px;
    background: rgba(0, 0, 0, .7);
    font-size: 14px;
    color: #fff;
  }

  .blank {
    min-height: 300px;
  }

  .error-title {
    font-size: 25px;
    text-align: center;
    margin-bottom: 15px;
  }

  .error-message {
    text-align: center;
  }

  .fa-exclamation-triangle {
    color: #e386ab;
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .information-container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      bottom: 100px;
      left: 0;
      right: 0;

      .item {
        border: 1px solid #ddd;
        border-radius: 6px;
        width: 700px;
        padding: 40px 0;
      }
    }

  }

  // 800まで
  @media screen and (max-width: 800px) {

    .information-container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      .item {
        width: 100%;
        padding: 40px 0;
      }
    }

  }

</style>
